import { render, staticRenderFns } from "./ManageFieldsDialog.vue?vue&type=template&id=2d658ef5"
import script from "./ManageFieldsDialog.vue?vue&type=script&lang=js"
export * from "./ManageFieldsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports